import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import { artavaBrand } from './artavaBrand';

const FOOTER_HEIGHT = 46;

function makeFooterText() {
  return `${artavaBrand.productName} • ${artavaBrand.footerAttribution} • ${artavaBrand.websiteHost}`;
}

export async function renderNodeToBrandedCanvas(node, {
  backgroundColor = '#ffffff',
  scale = 2,
} = {}) {
  const sourceCanvas = await html2canvas(node, {
    backgroundColor,
    scale,
    useCORS: true,
    scrollY: -window.scrollY,
  });
  return addBrandFooterToCanvas(sourceCanvas, backgroundColor);
}

export function addBrandFooterToCanvas(sourceCanvas, backgroundColor = '#ffffff') {
  const brandedCanvas = document.createElement('canvas');
  brandedCanvas.width = sourceCanvas.width;
  brandedCanvas.height = sourceCanvas.height + FOOTER_HEIGHT;
  const context = brandedCanvas.getContext('2d');

  context.fillStyle = backgroundColor;
  context.fillRect(0, 0, brandedCanvas.width, brandedCanvas.height);
  context.drawImage(sourceCanvas, 0, 0);

  context.fillStyle = '#e6edf4';
  context.fillRect(0, sourceCanvas.height, brandedCanvas.width, FOOTER_HEIGHT);
  context.fillStyle = '#102c42';
  context.font = 'bold 14px Arial';
  context.fillText(artavaBrand.productName, 18, sourceCanvas.height + 28);
  context.fillStyle = '#5f7283';
  context.font = '12px Arial';
  context.fillText(makeFooterText(), 18, sourceCanvas.height + 41);
  context.textAlign = 'right';
  context.fillStyle = '#173b57';
  context.font = 'bold 12px Arial';
  context.fillText(artavaBrand.websiteHost, brandedCanvas.width - 18, sourceCanvas.height + 28);
  context.textAlign = 'left';

  return brandedCanvas;
}

export async function exportNodeAsBrandedPNG(node, fileName, options = {}) {
  if (!node) return;
  const canvas = await renderNodeToBrandedCanvas(node, options);
  canvas.toBlob((blob) => {
    if (blob) saveAs(blob, `${fileName}.png`);
  });
}

export function applyBrandedPdfChrome(doc, { title = '', sourceLabel = '' } = {}) {
  const pageCount = doc.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  for (let page = 1; page <= pageCount; page += 1) {
    doc.setPage(page);
    doc.setDrawColor(223, 231, 238);
    doc.line(12, pageHeight - 12, pageWidth - 12, pageHeight - 12);
    doc.setFontSize(9);
    doc.setTextColor(95, 114, 131);
    doc.text(`${artavaBrand.productName} • ${artavaBrand.footerAttribution}`, 14, pageHeight - 7);
    doc.text(artavaBrand.websiteHost, pageWidth - 14, pageHeight - 7, { align: 'right' });
    if (page === 1 && title) {
      doc.setFontSize(11);
      doc.setTextColor(16, 44, 66);
      doc.text(`${artavaBrand.productName} ${sourceLabel ? `• ${sourceLabel}` : ''}`.trim(), 14, 10);
    }
  }
}
